import useAuth from 'features/auth/hooks/useAuth';
import useUser from 'features/user/hooks/useUser';
import React, { useState } from 'react';
import { getToken } from 'utils/localStorage';

export const useUserInit = () => {
  const { isLoggedIn } = useAuth();
  const { onProfile, isLoading, error } = useUser();

  const [initialized, setInitialized] = useState(false);

  React.useEffect(() => {
    if (isLoggedIn || isLoading || error) return;

    const token = getToken();

    if (token) {
      onProfile();
    } else {
      setInitialized(true);
    }
  }, [isLoggedIn, isLoading, onProfile, error]);

  React.useEffect(() => {
    if (isLoggedIn) {
      setInitialized(true);
    }
  }, [isLoggedIn]);

  return initialized;
};
